import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=50604abf&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QInput,QCheckbox,QBtn,QDialog,QCard,QCardSection,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QPage,QForm,QInput,QCheckbox,QBtn,QDialog,QCard,QCardSection,QSeparator,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
